import { useEffect, useState } from "react";
import { ReactComponent as ArrowSvg } from 'bimui/dist/c1/icons/dropdown.svg';
import { ContextMenuModal, IconButton, MenuItem, MenuList } from 'bimui'
import classNames from "classnames";

interface IconProps {
    key: string,
    icon: any
}

interface Iprops {
    idKey: string
    icons: IconProps[]
    selectedIcon: IconProps
    className?: string
    handleIconClick: (item: IconProps) => void
}

export default function ToolMenu(props: Iprops) {
    const { idKey, icons, selectedIcon, handleIconClick } = props;
    const [top, setTop] = useState(0); // 下拉菜单的top
    const [left, setLeft] = useState(0); // 下拉菜单的left
    const [showMenu, setShowMenu] = useState<boolean>(false); // 是否展示下拉菜单

    return (
        <>
            <div id={`operation-bar-btn-${idKey}`} className={classNames({
                "operation-bar-btn-panel": true,
            }, props.className || "")}>
                <IconButton icon={selectedIcon.icon} onClick={() => handleIconClick(selectedIcon)} style={{ width: 40 }}>
                    <ArrowSvg onClick={(e) => {
                        e.stopPropagation();
                        let dom = document.getElementById(`operation-bar-btn-${idKey}`);
                        let rect = dom.getBoundingClientRect();
                        setTop(rect.top + 32);
                        setLeft(rect.left - 5);
                        setShowMenu(true);
                    }} />
                </IconButton>
            </div>
            <ContextMenuModal
                visible={showMenu}
                left={left}
                top={top}
                onCancel={() => { setShowMenu(false) }}
                wrapperClassname='operation-bar-menu'>
                <MenuList>
                    {icons.map(item => (
                        <MenuItem onClick={() => { handleIconClick(item); setShowMenu(false); }}><IconButton icon={item.icon}></IconButton></MenuItem>
                    ))}
                </MenuList>
            </ContextMenuModal>
        </>
    )
}